import messages from './Messages';
import ItemView, {
  IComponentProps as IComponentBaseProps,
  IComponentState as IComponentBaseState,
} from './ItemView';
import { createSurveyReportItem } from 'store/providers/providerSlice';
import { IProviderItemViewWithData } from '../../../../store/providers/providerTypes';
import { green } from '../../../../utils/style/colors';
import { IUsers } from '../../../../store/store';
import i18n from '../../../../i18n';

interface IComponentProps extends IComponentBaseProps {
  listIndex?: number;
  onOpenFolder?: (index: number, id: number) => void;
  users?: IUsers;
}

interface IComponentState extends IComponentBaseState {
  activeLanguage: string;
}

class ReportView extends ItemView<IComponentProps, IComponentState> {
  constructor(props: IComponentProps) {
    super(props);
  }

  deleteItemTitle(name: string) {
    return messages.deleteSearchTagTitle(name);
  }

  deleteItemMessage(name: string) {
    return messages.deleteSearchTagMessage(name);
  }

  onOpenFunction(item: IProviderItemViewWithData, isNewTab: boolean) {
    return (e: any) => {
      this.props.onOpenItem(
        item,
        'view',
        undefined,
        isNewTab || e.altKey || e.metaKey
      );
    };
  }

  getThumbnail() {
    // if (this.props.item.data.thumbnailUrl) {
    //   return this.props.item.data.thumbnailUrl;
    // }
    // return this.chartImage;
    return ['presention-chart.svg', green];
  }

  handelConfirmCreatingNewItem(item: IProviderItemViewWithData) {
    this.props.dispatch(createSurveyReportItem({ item: item.data }));
  }

  newItemPlaceHolder() {
    return i18n.t('namePlaceHolder', { ns: 'documentManager' });
  }

  newItemTitle() {
    return i18n.t('nameTitle', { ns: 'documentManager' });
  }

  getMenuActions(itemId: number, editable: boolean) {
    const menuActions = super.getMenuActions(itemId, editable);
    return menuActions;
  }
}

export default ReportView;
